import React, { useEffect, useMemo, useState } from "react";

import ETAAircraft from "./ETAAircraft";
import STAAircraft from "./STAAircraft";

function TGUITimeline({ zoom = 1, aircraft, meterFix, selectAircraft }) {

  const etaAircraft = useMemo(() => {
    let nextAnchor = 1;
    return aircraft.map(a => {
      const anchor = Math.max(nextAnchor, a.eta);
      nextAnchor = anchor + 1;
      return (
        <ETAAircraft
          anchor={anchor}
          eta={a.eta}
          callsign={a.callsign}
          hasRadarTrack={a.hasRadarTrack}
          type={a.type}
          selectAircraft={selectAircraft}
        />
      );
    });
  }, [aircraft, selectAircraft]);

  const staAircraft = useMemo(() => {
    let nextAnchor = 1;
    return aircraft.map(a => {
      const anchor = Math.max(nextAnchor, a.eta);
      nextAnchor = anchor + 1;
      return (
        <STAAircraft
          anchor={anchor}
          eta={a.eta}
          callsign={a.callsign}
          type={a.type}
          isFrozen={a.isFrozen}
          delay={a.delay}
        />
      );
    });
  }, [aircraft]);

  const viewBox = useMemo(() => {
    const width = 50 / zoom;
    const height = 100 / zoom;
    const x = (50 - width) / 2;
    const y = 100 - height;
    return `${x} ${y} ${width} ${height}`;
  }, [zoom]);

  const notches = useMemo(() => {
    const notches = [];
    for (let i = 1; i < 95; i += 1) {
      if (i % 5 === 0) {
        notches.push(
          <path
            d={`M 23.25 ${i}, 24 ${i}`}
            fill="transparent"
            stroke="white"
            // vectorEffect="non-scaling-stroke"
            strokeWidth={0.07}
            className="dim"
          />
        );
        notches.push(
          <path
            d={`M 26 ${i}, 26.75 ${i}`}
            fill="transparent"
            stroke="white"
            // vectorEffect="non-scaling-stroke"
            strokeWidth={0.07}
            className="dim"
          />
        );
        const minutes = (95 - i) % 60;
        if (minutes === 0) {
          notches.push(
            <text
              x="25"
              y={i - 0.07}
              fill="#999"
              textAnchor="middle"
              alignmentBaseline="baseline"
              fontSize={1.1}
            >
              {`22`}
            </text>
          );
          notches.push(
            <text
              x="25"
              y={i + 0.07}
              fill="#999"
              textAnchor="middle"
              alignmentBaseline="hanging"
              fontSize={1.1}
            >
              {`00`}
            </text>
          );
        } else {
          notches.push(
            <text
              x="25"
              y={i}
              fill="#999"
              textAnchor="middle"
              alignmentBaseline="central"
              fontSize={1.1}
            >
              {`0${minutes}`.substr(-2)}
            </text>
          );
        }
      } else {
        notches.push(
          <path
            d={`M 23.5 ${i}, 24 ${i}`}
            fill="transparent"
            stroke="white"
            // vectorEffect="non-scaling-stroke"
            strokeWidth={0.07}
            className="dim"
          />
        );
        notches.push(
          <path
            d={`M 26 ${i}, 26.5 ${i}`}
            fill="transparent"
            stroke="white"
            // vectorEffect="non-scaling-stroke"
            strokeWidth={0.07}
            className="dim"
          />
        );
      }
    }
    return notches;
  }, []);

  return (
    <div className="tgui-timeline">
      <svg viewBox={viewBox} >
        <path
          d="M 24 94.8, 24 0"
          fill="transparent"
          stroke="white"
          // vectorEffect="non-scaling-stroke"
          strokeWidth={0.07}
          className="dim"
        />
        <path
          d="M 26 94.8, 26 0"
          fill="transparent"
          stroke="white"
          // vectorEffect="non-scaling-stroke"
          strokeWidth={0.07}
          className="dim"
        />
        <path
          d="M 23 95, 27 95"
          fill="transparent"
          stroke="white"
          // vectorEffect="non-scaling-stroke"
          strokeWidth={0.14}
          className="dim"
        />
        {notches}
        {etaAircraft}
        {staAircraft}
        <text
          x="25"
          y={96.5}
          fill="#00FD98"
          textAnchor="middle"
          alignmentBaseline="central"
          fontSize={0.9}
        >MF</text>
        <text
          x="23.25"
          y={97.5}
          fill="#999"
          textAnchor="end"
          alignmentBaseline="central"
          fontSize={0.9}
        >{meterFix}{/*"AQ"*/}</text>
        <text
          x="23.25"
          y={98.5}
          fill="#999"
          textAnchor="end"
          alignmentBaseline="central"
          fontSize={0.9}
        >All RWY</text>
        <text
          x="26.75"
          y={97.5}
          fill="#999"
          textAnchor="start"
          alignmentBaseline="central"
          fontSize={0.9}
        >{meterFix}{/*"AQ"*/}</text>
        <text
          x="26.75"
          y={98.5}
          fill="#999"
          textAnchor="start"
          alignmentBaseline="central"
          fontSize={0.9}
        >All RWY</text>
        <path
          d="
            M 23.5 94.5,
            24.5 94.5,
            24.5 93.7,
            24.2 94.0,
            24.2 94.2,
            23.5 94.2 Z
          "
          fill="#FD0000"
          stroke="#000"
          strokeWidth={0.07}
        />
        <path
          d="
            M 23.5 86.5,
            24.5 86.5,
            24.5 87.3,
            24.2 87.0,
            24.2 86.8,
            23.5 86.8 Z
          "
          fill="#FD0000"
          stroke="#000"
          strokeWidth={0.07}
        />
      </svg>
    </div>
  );
}

export default TGUITimeline;